export const isTokenManagementEnabled = process.env.REACT_APP_ENABLE_TOKEN_MANAGEMENT === 'true'
